export const viewTabMaxWidth = 400;
export const hierarchyViewIdSearchParamKey = "viewId";
